import { IButton } from "../../Button/Button";
import clsx from "clsx";
import ButtonGroup from "../../ButtonGroup/ButtonGroup";
import { memo, ReactNode } from "react";
import useMobile from "../../../hooks/useMobile";

interface IAccountNotFoundTextBlock {
  title?: string;
  icon?: ReactNode;
  description?: string;
  buttons?: Array<IButton>;
}

const AccountNotFoundTextBlock: React.FC<IAccountNotFoundTextBlock> = ({
  title,
  icon = null,
  description,
  buttons,
}) => {
  const { isMobile } = useMobile();

  return (
    <div
      className={clsx([
        "flex",
        "flex-col",
        "gap-1",
        "md:gap-6",
        "w-full",
        "items-center",
        "justify-center",
      ])}
    >
      <div
        className={clsx([
          "flex",
          "flex-row",
          "md:flex-col",
          "gap-4",
          "md:gap-6",
          "w-full",
          "items-center",
          "justify-center",
        ])}
      >
        {!!icon && icon}
        {!!(title || description) && (
          <div
            className={clsx([
              "flex",
              "w-full",
              "items-center",
              "justify-center",
              "gap-0",
              "flex-col",
            ])}
          >
            {!!title && (
              <div
                className={clsx([
                  "text-sm",
                  "uppercase",
                  // "md:normal-case",
                  "md:text-base",
                  "font-medium",
                  "flex",
                  "flex-col",
                  "justify-center",
                  "items-start",
                  "md:items-center",
                  "w-full",
                ])}
              >
                {title}
              </div>
            )}
            {!!description && (
              <div
                className={clsx([
                  "flex",
                  "flex-col",
                  "justify-center",
                  "items-start",
                  "md:items-center",
                  "w-full",
                  "text-sm",
                  "md:text-base",
                ])}
              >
                {description}
              </div>
            )}
          </div>
        )}
      </div>
      {!!buttons?.length && (
        <ButtonGroup
          gap={1}
          align={isMobile ? "right" : "center"}
          buttons={buttons}
          fullWidth
        />
      )}
    </div>
  );
};

export default memo(AccountNotFoundTextBlock);
